import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ILightWeightUser } from '@fi-shared/models';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';

@Component({
    selector: 'fi-users-list-related-to-object-type',
    template: `
        <div class="user-list-container">
          @for (userData of users$ | async; track userData) {
            <div class="user-wrapper" (click)="openUserOverlay(userData.Id)">
              <div class="user-avatar-container">
                <fi-profile-icon [profileData]="userData" [size]="FiProfileSizes.Size40px"> </fi-profile-icon>
              </div>
              <div class="user-data-container">
                <p class="user-name bold">{{ userData.FullName }}</p>
                <p class="user-business-unit-name">{{ userData.PreferredBusinessUnitName }}</p>
              </div>
            </div>
          }
        </div>
        `,
    styleUrls: ['./fi-users-list-related-to-object-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-users-list-related-to-object-type' },
    standalone: false,
})
export class FiUsersListRelatedToObjectTypeComponent {
    @Input() users$: BehaviorSubject<ILightWeightUser[]> = new BehaviorSubject<ILightWeightUser[]>([]);
    FiProfileSizes = FiProfileSizes;

    constructor(private sharedActionsBaseService: SharedActionsBaseService) {}

    openUserOverlay(userId: number) {
        this.sharedActionsBaseService.openUserViewPopup(userId);
    }
}
